export default __webpack_public_path__ + "static/media/cigar1.d0fd4b7b.jpg";